import React, { useState } from 'react';
import { ToolSubmenu } from './ToolSubmenu';

export default function SavedViewsStrip({
  open,
  layout = 'row',
  views,
  onClose,
  onSave,
  onShare,
  onApply,
  onCopyLink,
  onDelete,
}) {
  const [name, setName] = useState('');
  if (!open) return null;

  const isColumn = layout === 'column';

  const submit = (share) => {
    const trimmed = name.trim();
    if (share) onShare?.(trimmed);
    else onSave?.(trimmed);
    setName('');
  };

  return (
    <ToolSubmenu layout={layout} label="Views" onClose={onClose}>
      <div className={isColumn ? 'flex flex-col gap-1.5 w-full' : 'flex items-center gap-1.5 min-w-0 flex-1'}>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="View name"
          className="m-0 h-7 min-w-[7rem] flex-1 rounded-sm border border-yellow-600/30 bg-zinc-950 px-2 text-[11px] text-zinc-200 focus:border-yellow-400 focus:outline-none"
        />
        <button
          type="button"
          className="m-0 h-7 px-2 shrink-0 rounded-sm border border-yellow-600/40 bg-yellow-500 text-[10px] font-semibold uppercase tracking-wider text-black hover:bg-yellow-400"
          onClick={() => submit(false)}
          title="Save on this browser only"
        >
          Save
        </button>
        <button
          type="button"
          className="m-0 h-7 px-2 shrink-0 rounded-sm border border-yellow-600/40 text-[10px] font-semibold uppercase tracking-wider text-yellow-400 hover:bg-yellow-500/10"
          onClick={() => submit(true)}
          title="Share with everyone on this site"
        >
          Share
        </button>
        <div className={isColumn ? 'flex flex-col gap-1 w-full' : 'flex items-center gap-1 overflow-x-auto min-w-0'}>
          {(views || []).length === 0 ? (
            <span className="text-[10px] text-zinc-500 px-1">No saved views</span>
          ) : (
            views.map((v, i) => {
              const n = Number(v.order);
              const label = Number.isFinite(n) ? `${n}. ${v.name}` : `${i + 1}. ${v.name}`;
              return (
              <span
                key={v.id}
                className="inline-flex items-center gap-0.5 shrink-0 rounded-sm border border-yellow-600/30 bg-zinc-950"
              >
                <button
                  type="button"
                  className="m-0 h-7 px-2 text-[10px] uppercase tracking-wider text-yellow-400 hover:bg-yellow-500/10"
                  onClick={() => onApply?.(v)}
                  title={v.shared ? `${label} (shared)` : label}
                >
                  {label}
                  {v.shared ? (
                    <span className="ml-1 text-[8px] text-zinc-500 normal-case tracking-normal">shared</span>
                  ) : null}
                </button>
                <button
                  type="button"
                  className="m-0 h-7 w-6 text-zinc-500 hover:text-sky-400"
                  title="Copy link to this view"
                  onClick={() => onCopyLink?.(v)}
                >
                  ↗
                </button>
                {Number(v.createdBy) !== 0 ? (
                <button
                  type="button"
                  className="m-0 h-7 w-6 text-zinc-500 hover:text-red-400"
                  title={v.shared ? 'Delete shared view' : 'Delete view'}
                  onClick={() => onDelete?.(v)}
                >
                  ×
                </button>
                ) : null}
              </span>
              );
            })
          )}
        </div>
      </div>
    </ToolSubmenu>
  );
}
